import React, { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    
    const initApp = async () => {
      try {
        
        setTimeout(() => setLoading(false), 1500);
      } catch (error) {
        console.error("App Initialization Failed:", error);
      }
    };

    initApp();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-navy flex flex-col items-center justify-center">
        <div className="w-16 h-16 border-4 border-amazon-yellow border-t-transparent rounded-full animate-spin mb-4"></div>
        <h1 className="text-white font-black italic uppercase tracking-widest animate-pulse">
          Kolkata <span className="text-amazon-yellow">Super</span>
        </h1>
        <p className="text-gray-500 text-[10px] mt-2 font-bold uppercase">Connecting to Secure Point Arena...</p>
      </div>
    );
  }

  return (
    <div className="App selection:bg-orange selection:text-white min-h-screen bg-bg-gray">
      {}
      <Dashboard />;
      
      {}
    </div>
  );
}

export default App;